import React, { useState, useEffect, useCallback } from 'react';
import { DataTable, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { getBannerList } from '../../api/banner';
import dayjs from 'dayjs';
import { DATETIME_FORMAT } from '../../shared/constants';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const Banner = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const getFileName = useCallback((data) => {
        if (data.attachmentId && typeof data.attachmentId === 'object') {
            return data.attachmentId.originalName || data.attachmentId.name || '-';
        }
        return data.fileName || '-';
    }, []);

    const columns = [
        { key: "title", label: t("TITLE"), },
        {
            key: "fileName",
            label: t("FILE_NAME"),
            render: (v, data) => {
                return getFileName(data)
            }
        },
        { key: "description", label: t("DESCRIPTION"), },
        { key: "isPublish", label: t("IS_PUBLISH"), render: (v, data) => data.isPublish.toString(), },
        { key: "sequence", label: t("SEQUENCE"), },
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT) },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.BannerDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    useEffect(() => {
        getData(pagination)
    }, [pagination])

    const getData = async (pagination) => {
        const response = await getBannerList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper
            headerProps={{
                title: "BANNER",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={() => navigate(Pages.BannerDetail.replace(":id", "new"))}>{t("ADD")}</Button>
            }}
        >
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default Banner;
